export const regexPattern = {
  PASSWORD: /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  FACEBOOK: /^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9(.?)?]/,
  INSTAGRAM: /^(https?:\/\/)?(www\.)?instagram.com\/[a-zA-Z0-9(.?)?]/,
  YOUTUBE: /((http(s)?:\/\/)?)(www\.)?((youtube\.com\/)|(youtu.be\/))[\S]+/,
  SPOTIFY: /^(https?:\/\/)?(www\.)?open.spotify.com|spotify.com\/[a-zA-Z0-9(.?)?]/,
  TWITTER: /^(https?:\/\/)?(www\.)?twitter.com\/[a-zA-Z0-9(.?)?]/,
  // eslint-disable-next-line max-len
  WEBSITE: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  NUMBER_ONLY: /^[0-9]+$/,
  NUMBER_ONLY_WITH_DECIMAL: /^\d{0,10}(\.\d{0,2})?$/,
  NUMBER_ZERO_TO_HUNDRED: /^[0-9]$|^[1-9][0-9]$|^(100)$/,
  NUMBER_ZERO_TO_HUNDRED_DECIMAL: /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/,
  // eslint-disable-next-line no-useless-escape
  ADD_HTTP: /^(?:f|ht)tps?\:\/\//,
};

export const MIME_TYPE_REGEX = {
  VIDEO: /(\.mp4|\.flv|\.3gp|\.mov|\.avi|\.wmv|\.m3u8|\.mpeg|\.ogv|\.webm)$/i,
  IMAGE: /(\.jpg|\.jpeg|\.png|\.gif|\.tiff|\.webp|\.ico)$/i,
};

export const validationMessages = {
  PASSWORD: 'The password must contain at least: 1 lowercase letter, 1 uppercase, 1 number, and one special character',
  EMAIL: 'Please enter a valid email.',
  FACEBOOK: 'Please enter a valid facebook url.',
  INSTAGRAM: 'Please enter a valid instagram url.',
  YOUTUBE: 'Please enter a valid youtube url.',
  SPOTIFY: 'Please enter a valid spotify url.',
  TWITTER: 'Please enter a valid twitter url.',
  WEB: 'Please enter a valid url.',
  REQUIRED: 'Mandatory!',
  PROFILE_IMAGE: 'Only .png, .jpg are allowed with maximum size up to 10 mb.',
  CONFIRM_PASSWORD: 'Passwords don\'t match',
  START_AGE: 'Start age can not be greater than end age',
  END_AGE: 'End age can not be less than start age',
  START_DATE: 'Start date can not be greater than end date',
  END_DATE: 'End date can not be less than start date',
  INVITE_ARTIST: 'Please select atleast one artist to publish opportunity.',
  INVALID: 'invalid!',
  DOWNLOAD_FAILED: 'Download failed',
  GREATER_THAN_TODAY: "Should be greater than today's date",
  LESS_THAN_MAX_DATE: 'Should be less than max offer date.',
  START_DATE_ERROR_MSG: 'Invalid',
  INVALID_OFFER_URL_ERROR: 'Invalid Url',
};

export const CHAT_MESSAGE_TYPE = {
  TEXT: 'text',
  MEDIA: 'media',
};

export const MEDIA_VIEW_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
};

export const Messages = {
  registerSuccess: 'Thank you for applying on BYGMusic, We will get back to you shortly.',
  copyLinkSuccess: 'Link copied successfully.',
};

export const OFFER_DETAIL_LISTING = {
  PARTICIPATING_ARTIST: 'participatingArtist',
  PENDING_CONTRACT: 'pendingContract',
  REJECTED_ARTIST: 'rejectedArtist',
};

export const countryList = [
  { value: 'us', label: 'United States' },
];

export const cityList = [
  { value: 'newyork', label: 'New York' },
  { value: 'chicago', label: 'Chicago' },
];

export const genre = [
  { value: 'folkMusic', label: 'Folk Music' },
  { value: 'reggae', label: 'Reggae' },
];

export const INVITATION_STATUS = {
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  REQUESTED: 'requested',
  EXPIRED: 'expired',
};

export const staticConstants = {
  ROLE: { MANAGER: 'manager', ARTIST: 'artist', SYSTEM_ADMIN: 'systemAdmin' },
  PROFILE_IMAGE_MIME: ['image/png', 'image/jpeg', 'image/gif'],
  TITLE: { MANAGER: 'I’m a Label', ARTIST: 'I’m an Artist' },
  BUTTON_TITLE: { CREATE: 'Create my account', UPDATE: 'Update profile details' },
  ROLE_TYPE: { MANAGER: 'Label', ARTIST: 'Artist', SYSTEM_ADMIN: 'System Admin' },
  ROLE_HEADER: {
    '/admin/manager': 'Labels', '/admin/artist': 'Artists', '/admin/offer': 'Opportunities', '/admin/analytics': 'Campaign analytics',
  },
  STATUS_TYPE: {
    REQUESTED: 'requested',
    REJECTED: 'rejected',
    DELETED: 'deleted',
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated',
    LEAD_GENERATION: 'leadGeneration',
    BRANDED_CONTENT: 'brandedContent',
    AWARENESS: 'awareness',
    PUBLIC: 'public',
    PRIVATE: 'private',
    AFFILIATE: 'affiliate',
    ADMIN_ACCEPTED: 'adminAccepted',
    EXPIRED_OFFER: 'isExcludeExpiredOffer',
    APPROVED: 'betaPostApproved',
    UNREAD_MESSAGE_OFFER: 'isUnreadMessage',
  },
  STATUS_NAME: {
    active: 'Active',
    requested: 'Request',
    rejected: 'Rejected',
    deactivated: 'Deactivated',
    deleted: 'Deleted',
  },
  EDIT_PROFILE_TITLE: { MANAGER: 'Edit Label Detail', ARTIST: 'Edit Artist Detail' },
  HEADER_CONSTANTS: {
    FILTER_BY_STATUS: 'Filter by status',
    NEW_REQUEST: 'New request',
    ACTIVE: 'Active',
    REJECTED: 'Rejected',
    DELETED: 'Deleted',
    DEACTIVATED: 'Deactivated',
    STATUS: 'Status',
    FILTER_BY_BRAND: 'Filter by Brand',
    FILTER_BY_DEMOGRAPHICS: 'Filter by Demographics',
    POSTS_DUE_TODAY: 'POSTS DUE TODAY',
    TOTAL: 'Total',
    NO_NEW_POSTS: 'Click on social media icon(s) to view posts',
    POSTED_TODAY: 'Posted today',
  },
  REQUEST_REJECT_REASON_LABEL: '"We regret to inform you BYGMusic will not be able to work with you at this time."',
  REQUEST_REJECT_REASON: [
    { value: 1, label: 'We enjoyed looking at your profile and look forward to working with you when you have expanded your digital reach.' },
    { value: 2, label: 'We have found issue with brand safety on your social accounts.' },
  ],
  OFFER_REJECT_REASON: [
    { value: 1, label: 'Your fans are not the right audience.' },
    { value: 2, label: 'You are not based in the right area.' },
    { value: 3, label: 'Your social isn\'t large enough.' },
  ],
  MODAL_POPUP_TYPE: {
    ACTIVE: 'active',
    REQUESTED: 'requested',
    REJECTED: 'rejected',
    EDIT_PROFILE: 'editProfile',
    DEACTIVATED: 'deactivated',
    DELETE: 'deleted',
  },
  ERROR_CLASS: {
    FORM_ERROR: 'form-error',
  },
  SOCIAL_SHARE_TYPE: {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    TWITTER: 'twitter',
    SPOTIFY: 'spotify',
    YOUTUBE: 'youtube',
  },
  STATUS_TYPE_CLASSNAME: {
    ACCEPT: 'accept',
    REJECT: 'reject',
    REQUESTED: 'pending',
    COMPLETED: 'completed',
  },
  ARTIST_REQUEST_REJECT_REASON: [
    { value: 1, label: 'Missing tags and hashtags' },
    { value: 2, label: 'Let\'s chat. When are you free to speak?' },
  ],
  REQUEST_MESSAGE: '"Thank you for submitting your beta post. At this time, it needs edits."',
  COMPONENT_KEYWORDS: {
    ADMIN_ANALYTICS_PAGE: 'analyticsPage',
    ADMIN_ARTIST_PAGE: 'artistPage',
    ADMIN_MANAGER_PAGE: 'managerPage',
  },
};

export const dateFormats = {
  DATE_WITHOUT_YEAR: 'MMM DD',
  DATE_WITH_YEAR: 'MMM DD, YYYY',
  DAY_DATE_WITHOUT_YEAR: 'dddd, MMM DD',
  DAY_DATE_WITH_YEAR: 'dddd, MMM DD, YYYY',
  MESSAGE_DATE_FORMAT: 'DD, MMMM YYYY',
  MESSAGE_TIME_FORMAT: 'HH:mm',
  DATE_WITH_TIME: 'MMM DD, YYYY, hh:mm a',
};

export const customSelectStyles = {
  option: (provided, state) => ({
    color: state.isFocused ? '#340068' : '#000000',
    padding: '14px 19px',
    fontSize: '14px',
    cursor: 'pointer',
    margin: 0,
    borderRadius: '2px',
    fontWeight: state.isFocused ? '600' : '500',
    background: state.isFocused ? '#eeeaf3' : '#ffffff',
  }),
  menu: () => ({
    border: '0',
    padding: '25px 6px',
    boxShadow: '0 11px 24px 0 rgba(0, 0, 0, 0.08)',
    background: '#ffffff',
    position: 'absolute',
    top: 'calc(100% - 6px)',
    zIndex: '1',
    width: '100%',
    borderRadius: '2px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
};

export const modalHight = {
  height: window.innerHeight,
};
export const bodyStyle = {
  paddingRight: document.body.style.paddingRight,
};

export const loaderStyle = {
  spinner: (base) => ({
    ...base,
    width: '60px',
    '& svg circle': {
      stroke: '#2a0f5a',
    },
  }),
  overlay: (base) => ({
    ...base,
    zIndex: '99999',
    background: 'none',
  }),
};

export const FILTER_CATEGORY = {
  CATEGORY: 'category',
  SUB_CATEGORY: 'subCategory',
  ALL: 'all',
};

export const DEMO_FILTER_CATEGORY = {
  ETHNICITY: 'ethnicity',
  GENDER: 'gender',
  COUNTRY: 'country',
  AGE: 'age',
};

export const ARTIST_OFFER_LIST_STATUS = {
  OFFER_BOARD: 'offerBoard',
  MY_OFFER: 'myOffer',
  PASSED_OFFER: 'passedOffer',
  FOR_ME: 'forMe',
  OFFER_BOARD_REQUESTED: 'offerBoardRequested',
  EXPIRED: 'expired',
  MESSAGE_BOARD: 'messageBoard',
  AFFILIATE_OFFERS: 'affiliateOffer',
};
export const OFFER_TABS = {
  ALL_OFFERS: '1', PRIVATE_OFFERS: '4', AFFILIATE_OFFERS: '5', MY_OFFERS: '2', PASSED_OFFERS: '3',
};
export const CAMPAIGN_TYPE = [
  { index: 1, label: 'Lead generation', value: 'leadGeneration' },
  { index: 2, label: 'Awareness', value: 'awareness' },
  { index: 3, label: 'Branded content', value: 'brandedContent' },
];

export const VIEW_TYPE = [
  { index: 1, label: 'Public', value: 'public' },
  { index: 2, label: 'Private', value: 'private' },
  { index: 3, label: 'Affiliate', value: 'affiliate' },
];

export const PUBLIC_GIG_TYPE = [
  { index: 1, label: 'Standard', value: 'standard' },
  { index: 2, label: 'Trade-out', value: 'tradeout' },
  { index: 3, label: 'Livestream', value: 'livestream' },
];

export const BETA_POST_APPROVAL_TYPE = [
  { index: 1, label: 'Requires approval', value: false },
  { index: 2, label: 'No approval required, Direct post', value: true },
];

export const ARTIST_PARTICIPATION_TYPE = [
  { index: 1, label: 'Requires approval', value: false },
  { index: 2, label: 'Auto approval', value: true },
];

export const OFFER_TYPE = {
  leadGeneration: 'Lead generation',
  awareness: 'Awareness',
  brandedContent: 'Branded content',
  public: 'Public',
  private: 'Private',
  affiliate: 'Affiliate',
  livestream: 'Livestream',
  tradeout: 'Trade-out',
  standard: 'Standard',
};

export const TIME_IN_NUMBER = {
  MINUTE_SECONDS: 60,
  HOUR_SECONDS: 60 * 60,
  DAY_SECONDS: 60 * 60 * 24,
};

export const NUMERIC_VALUE = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  EIGHT: 8,
  TEN: 10,
  TWELVE: 12,
  TWENTY: 20,
  TWENTY_FOUR: 24,
  FIFTY: 50,
  HUNDRED: 100,
  TWO_HUNDRED: 200,
  TWO_HUNDRED_FIFTY: 200,
  THREE_HUNDRED: 300,
  FIVE_HUNDRED: 500,
  THOUSAND: 1000,
  THREE_THOUSAND: 1000,
  TEN_THOUSAND: 10000,
  SIXTY: 60,
  MAX_PROFILE_IMAGE_SIZE: 10000000,
  TEN_LAKH: 1000000,
  BILLION: 1000000000,
  MAX_BASE_PRICE_TEXT_LIMIT: 30,
  MAX_BASE_PRICE_TEXT_LIMIT_IN_DETAIL: 60,
  MAX_BASE_PRICE_INPUT_LIMIT: 100,
};

export const GRAPH_CONST_VALUES = {
  AUDIENCE: 'audience',
  ENGAGEMENT: 'engagement',
  AUTHENTIC: 'authntic',
  ETHNICITY: 'ethnicity',
  SIXTY_FIVE_PLUS: '65+',
  SIXTY_FIVE_MINUS_PLUS: '65-plus',
  FOLLOWERS: {
    FACEBOOK: 'facebookFollowers',
    INSTAGRAM: 'instagramFollowers',
    TWITTER: 'twitterFollowers',
    SPOTIFY: 'spotifyFollowers',
    YOUTUBE: 'youtubeFollowers',
  },
  AUTHENTIC_LABEL: 'Authentic Followers',
  AUTHENTIC_FOLLOWERS: 'authenticFollowers',
  AUDIENCE_AGE: {
    AGE_13_17: 'age_13_17',
    AGE_18_20: 'age_18_20',
    AGE_21_24: 'age_21_24',
    AGE_25_29: 'age_25_29',
    AGE_30_34: 'age_30_34',
    AGE_35_44: 'age_35_44',
    AGE_45_64: 'age_45_64',
    AGE_65_PLUS: 'age_65_plus',
  },
  AGE_LABEL: {
    AGE_13_17: '13-17 Yr',
    AGE_18_20: '18-20 Yr',
    AGE_21_24: '21-24 Yr',
    AGE_25_29: '25-29 Yr',
    AGE_30_34: '30-34 Yr',
    AGE_35_44: '35-44 Yr',
    AGE_45_64: '45-64 Yr',
    AGE_65_PLUS: '65+ Yr',
  },
  ETHNICITY_LABEL: {
    AMERICAN: 'African/American',
    WHITE: 'White/Caucasian',
    ASIAN: 'Asian',
    HISPANIC: 'Hispanic',
  },
  ETHNICITY_VALUE: {
    AMERICAN: 'american',
    WHITE: 'white',
    ASIAN: 'asian',
    HISPANIC: 'hispanic',
  },
  INSTA_RATE: 'instagramRate',
  FB_RATE: 'facebookRate',
  TWITTER_RATE: 'twitterRate',
  STATE_ONE: 'state1',
  STATE_TWO: 'state2',
  STATE_THREE: 'state3',
  STATE_FOUR: 'state4',
  STATE_FIVE: 'state5',
  COUNTRY_ONE: 'country1',
  COUNTRY_TWO: 'country2',
  COUNTRY_THREE: 'country3',
  STATE_COUNTRY_ONE: 'stateCountry1',
  STATE_COUNTRY_TWO: 'stateCountry2',
  STATE_COUNTRY_THREE: 'stateCountry3',
  STATE_COUNTRY_FOUR: 'stateCountry4',
  STATE_COUNTRY_FIVE: 'stateCountry5',
  STATE_FOLLOWERS_ONE: 'stateFollowers1',
  STATE_FOLLOWERS_TWO: 'stateFollowers2',
  STATE_FOLLOWERS_THREE: 'stateFollowers3',
  STATE_FOLLOWERS_FOUR: 'stateFollowers4',
  STATE_FOLLOWERS_FIVE: 'stateFollowers5',
  COUNTRY_FOLLOWERS_ONE: 'countryFollowers1',
  COUNTRY_FOLLOWERS_TWO: 'countryFollowers2',
  COUNTRY_FOLLOWERS_THREE: 'countryFollowers3',
};

export const graphDefaultValue = {
  isDefaultData: true,
  followers: {
    instagram: '',
    facebook: '',
    spotify: '',
    youtube: '',
    twitter: '',
  },
  authenticFollowers: '',
  audienceAge: {
    age_13_17: '',
    age_18_20: '',
    age_21_24: '',
    age_25_29: '',
    age_30_34: '',
    age_35_44: '',
    age_45_64: '',
    age_65_plus: '',
  },
  topCountry: {
    country1: null,
    country2: null,
    country3: null,
    countryFollowers1: '',
    countryFollowers2: '',
    countryFollowers3: '',
  },
  topState: {
    stateCountry1: null,
    state1: null,
    stateCountry2: null,
    state2: null,
    stateCountry3: null,
    state3: null,
    stateCountry4: null,
    state4: null,
    stateCountry5: null,
    state5: null,
    stateFollowers1: '',
    stateFollowers2: '',
    stateFollowers3: '',
    stateFollowers4: '',
    stateFollowers5: '',
  },
  audienceGender: {
    male: '',
    female: '',
  },
  audienceEthnicity: {
    american: '',
    asian: '',
    white: '',
    hispanic: '',
  },
  engagementRate: {
    instagramRate: '',
    facebookRate: '',
    twitterRate: '',
  },
};

export const ARTIST_PRIVATE_REQUEST = {
  ARTIST_ACCEPTED: 'artistAccepted',
  ARTIST_REMOVED: 'artistRemoved',
};

export const BYGMUSIC_CONTRACT = {
  contractHeader: 'BYGMusic LLC. INFLUENCER AGREEMENT',
  contractDescriptionStart: 'Please go through the agreement and click on',
  contractDescriptionEnd: 'at the end of the page to confirm this opportunity.',
  acceptContract: '“Accept contract”',
  influencer: 'Influencer',
  name: 'Name:',
  address: 'Address:',
  emailAddress: 'Email address:',
  bygMusic: 'BYGMusic, LLC.',
  title: 'Title:',
  ownerName: 'Krish Sharma',
  designation: 'CEO',
};

export const OFFER_STATUS = {
  ADMIN_REQUESTED: 'adminRequested',
  ADMIN_ACCEPTED: 'adminAccepted',
  ARTIST_ACCEPTED: 'artistAccepted',
  CONTRACT_ACCEPTED: 'contractAccepted',
  ARTIST_REQUESTED: 'artistRequested',
  PUBLISHED: 'published',
  COMPLETED: 'completed',
};

export const GRAPH_COLOR_CODE = {
  GREEN: '#94e7b8',
  LIGHT_GREEN: '#e6efea',
  GRAY: '#eeeeee',
};

export const CHAT_CONSTANTS = {
  ROOMS: 'rooms',
  CHAT: 'chat',
  MESSAGE_BOARD: 'messageBoard',
  MESSAGES: 'messages',
  GOAL_ID: 'goalId',
  CHAT_ROOMS: 'ChatRooms',
  CHAT_HISTORY: 'history',
  TIMESTAMP: 'timestamp',
  BROADCAST: 'broadcast',
  SENT_MESSAGE: 'send',
  RECEIVED_MESSAGE: 'received',
  USERS: 'users',
};

export const _TYPE_NAME = '__typename';

export const BETA_POST_ENUM = {
  ELIGIBLE: 'eligible',
  NOT_ELIGIBLE: 'notEligible',
  BETA_POST_CREATED: 'betaPostCreated',
  BETA_POST_APPROVED: 'betaPostApproved',
  BETA_POST_REQUESTED_ADMIN: 'betaPostRequestedAdmin',
  PUBLISHED: 'published',
  REJECTED: 'rejected',
  COMPLETED: 'completed',
};

export const BETA_POST_TITLE = {
  NO_BETA_POST_REQUEST: 'No draft post request',
  BETA_POST_REQUEST: 'Draft post request',
};

export const RECENT_ACTIVITIES = {
  NEW_OFFER: 'newOffer',
  ARTIST_APPLIED: 'artistApplied',
  OFFER_ACCEPTED: 'offerAccepted',
  REJECT_OFFER_REQUEST: 'rejectOfferRequest',
  ACCEPT_CONTRACT: 'acceptContract',
  ADMIN_ACCEPTED: 'adminAccepted',
  ADMIN_REJECTED: 'adminRejected',
  BETA_POST_REQUEST_REQUEST: 'betaPostRequest',
  BETA_POST_APPROVE: 'betaPostApprove',
  BETA_POST_REJECT: 'betaPostReject',
  INVITE_MANAGER: 'inviteManager',
  CONTRACT_PENDING: 'contractPending',
  PENDING_BETA_POST: 'pendingBetaPost',
  MISSED_DEADLINE_BETA_POST: 'missedDeadLineBetaPost',
  NO_RECENT_ACTIVITY_TEXT: 'You have no recent activities.',
};

export const RECENT_ACTIVITIES_MESSAGES = {
  NEW_OFFER: 'A new opportunity on your dashboard',
  ARTIST_APPLIED: 'You have applied on one of our opportunities',
  OFFER_ACCEPTED: 'You have accepted an opportunity',
  REJECT_OFFER_REQUEST: 'You have removed an opportunity',
  ACCEPT_CONTRACT: 'You have accepted the contract on',
  ADMIN_ACCEPTED: 'BYGmusic has accepted your opportunity request on ',
  ADMIN_REJECTED: 'BYGmusic has rejected your opportunity request on',
  BETA_POST_REQUEST_REQUEST: 'You have submitted a beta post for approval on an opportunity',
  MISSED_DEADLINE: 'You have missed a deadline on your campaign.',
};

export const MIME_TYPES = {
  DOC: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.text',
    ''],
  PDF: ['application/pdf'],
  XLS: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  VIDEO: ['video/x-msvideo', 'video/mpeg', 'video/ogg', 'video/mp2t', 'video/webm', 'video/mp4'],
};

export const STATUS_TYPE_NAME = {
  ELIGIBLE: 'Create draft post',
  BETA_POST_CREATED: 'Draft post sent for approval',
  BETA_POST_APPROVED: 'Draft post accepted. Publish post',
  REJECTED: 'Draft post rejected',
  COMPLETED: 'Completed',
};

export const DEMO_FILTER_DATA = {
  ethnicity: [{ name: 'american', _id: '01' }, { name: 'asian', _id: '02' },
    { name: 'white', _id: '03' }, { name: 'hispanic', _id: '04' }],
  gender: [{ name: 'male', _id: '01' }, { name: 'female', _id: '02' }],
  ageRange: [{ name: 'age_13_17', _id: '01' }, { name: 'age_18_20', _id: '02' }, { name: 'age_21_24', _id: '03' },
    { name: 'age_25_29', _id: '04' }, { name: 'age_30_34', _id: '05' }, { name: 'age_35_44', _id: '06' },
    { name: 'age_45_64', _id: '07' }, { name: 'age_65_plus', _id: '08' }],
  AGE_VALUE: {
    age_13_17: '13-17 Yr',
    age_18_20: '18-20 Yr',
    age_21_24: '21-24 Yr',
    age_25_29: '25-29 Yr',
    age_30_34: '30-34 Yr',
    age_35_44: '35-44 Yr',
    age_45_64: '45-64 Yr',
    age_65_plus: '65+ Yr',
  },
};

export const TIMELINE_CONSTANTS = {
  DUE_TODAY: 'Due today',
  EXPIRED: 'Expired',
};

export const TARGET_AUDIENCE_RANGE = [
  {
    name: 'age_13_17',
    key: 'checkBox1',
    label: '13-17 Yr',
  },
  {
    name: 'age_18_20',
    key: 'checkBox2',
    label: '18-20 Yr',
  },
  {
    name: 'age_21_24',
    key: 'checkBox3',
    label: '21-24 Yr',
  },
  {
    name: 'age_25_29',
    key: 'checkBox4',
    label: '25-29 Yr',
  },
  {
    name: 'age_30_34',
    key: 'checkBox5',
    label: '30-34 Yr',
  },
  {
    name: 'age_35_44',
    key: 'checkBox6',
    label: '35-44 Yr',
  },
  {
    name: 'age_45_64',
    key: 'checkBox7',
    label: '45-64 Yr',
  },
  {
    name: 'age_65_plus',
    key: 'checkBox8',
    label: '65+ Yr',
  },
];

export const CSV_COLUMN_ARTIST_HEADERS = [
  'name',
  'country',
  'state',
  'city',
  'genre',
  'bio',
  'primaryContactName',
  'email',
  'contactNumber',
  'shippingAddress',
  'image',
  'instagram',
  'facebook',
  'spotify',
  'youtube',
  'twitter',
  'website',
];

export const CSV_COLUMN_MANAGER_HEADERS = [
  'name',
  'labelFirstName',
  'labelLastName',
  'country',
  'state',
  'city',
  'genre',
  'bio',
  'primaryContactName',
  'email',
  'companyName',
  'contactNumber',
  'shippingAddress',
  'artistImage',
  'labelImage',
  'instagram',
  'facebook',
  'spotify',
  'youtube',
  'twitter',
  'website',
];
